export const ResetCode = "[%CLEARDOWN]";
export const ResetPropagator = "resetPropagator";
